<template>
<div class="d-flex h-100">
  <h6 class ='mt-3'> {{ 'ADD_CONDITION_IN_RULE' | translate }}</h6>
  <select size="10" v-model="selectedRowIdx" class="form-control form-control-sm mt-3">
    <option v-for="(row, key) in dslClauses" :value="key"
            @dblclick="onConfirm">{{ row }}</option>
  </select>
  <div class="mt-4 text-right">
    <button class="btn btn-sm btn-link"
            @click="onClose">
      {{ 'CLOSE' | translate }}
    </button>
    <button class="btn btn-sm btn-success"
            @click="onConfirm">
      {{ 'ADD' | translate }}
    </button>
  </div>
</div>
</template>

<script>
import RestService from '../../../service/RestService.js';

export default {
  props: ['selectedClause', 'selectedIndex', 'dslService'],
  data: function () {
    return {
      rest: new RestService(),
      selectedRowIdx: null
    }
  },
  computed: {
    dslClauses: function() {
      return this.dslService.getAllDslClausesOfType(this.selectedClause);
    },
    selectedRowToAdd: function() {
      return this.dslClauses[this.selectedRowIdx];
    }
  },
  methods: {
    onClose: function() {
      this.$emit('selection-modal-index', this.selectedRowIdx);
      this.$emit('hide-rule-add');
    },
    onConfirm: function() {
      this.$emit('selection-modal-index', this.selectedRowIdx);
      this.$emit('add-clause-row', this.selectedRowToAdd)
    }
  }
}
</script>

<style scoped>
  .d-flex.h-100 {
    flex-direction: column;
  }
  select.form-control {
    flex-grow: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/rules/RuleAddModal.vue